import Color from 'color';
import { Divider } from '@mui/material';
import { styled } from '@mui/styles';

export const StyledDivider = styled(Divider)(({ theme }) => {
  return {
    backgroundColor: Color(theme.palette.background.active)
      .darken(0.05)
      .toString(),
  };
});
